export default __webpack_public_path__ + "static/media/payment-cards.ed5851a0.png";